export function getApiUrl() {
  const liveAPI = "https://erpnew.onlinevidyalaya.net"; // your live API

  const hostname = typeof window !== "undefined" ? window.location.hostname : "";

  const apiURL = hostname === process.env.NEXT_PUBLIC_HOSTNAME ? liveAPI : process.env.NEXT_PUBLIC_ERPAPI;

  return apiURL;
}
